import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bcabf4a&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=0bcabf4a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=0bcabf4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcabf4a",
  null
  
)

export default component.exports